import moment from "../node_modules/moment/moment";
import { App } from "./App";
import { MultiLanguage } from "./MultiLanguage";
let app = new App();

class OepDocument {
    private _id: string;
    private _publicationDate: moment.Moment;
    private _title: MultiLanguage;
    private _description: MultiLanguage;
    private _extension: string;
    private _size: number;
    private _urlToDownload: string;
    private _externalUrl: string;

    constructor(data: any) {
        this._id = data.id;
        this._publicationDate = moment(data.publicationDate);
        this._title = new MultiLanguage(data.name);
        this._description = new MultiLanguage(data.description);
        this._urlToDownload = app.requestTo + data.url + "?origin=" + app.origin;
        this._extension = data.extension;
        this._size = data.size;
        this._externalUrl = data.externalUrl ? data.externalUrl : null;
    }

    public set id(id: string) {
        this._id = id;
    }
    public get id(): string {
        return this._id;
    }
    public get publicationDate(): moment.Moment {
        return this._publicationDate;
    }
    public get title(): MultiLanguage {
        return this._title;
    }
    public get description() {
        return this._description;
    }
    public get extension() {
        return this._extension;
    }
    public get size() {
        return this._size;
    }
    public get urlToDownload() {
        return this._urlToDownload;
    }
    public get externalUrl() {
        return this._externalUrl;
    }
    public set externalUrl(externalUrl: string) {
        this._externalUrl = externalUrl;
    }

}

export { OepDocument };